(function(){'use strict';

// ─── SCROLL REVEAL ───────────────────────────────────────────────────────────
function initScrollReveal(){
  var groups=[
    ['.al-s-label','.al-s-h','.al-s-sub'],
    ['.al-p-card'],
    ['.al-pk'],
    ['.al-rv'],
    ['.al-pp'],
    ['.al-ra__item'],
    ['.al-sp__item'],
    ['.al-promise__kicker','.al-promise__h']
  ];

  var allEls=[];

  groups.forEach(function(selectors){
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        if(el.closest('.al-hero')) return;
        el.classList.add('al-anim-reveal');
        allEls.push(el);
      });
    });
  });

  // Stagger siblings inside grids
  var gridSelectors=['.al-feat-grid','.al-cat-grid','.al-packs__grid','.al-rv-grid','.al-promise__grid','.al-ra','.al-sp__inner'];
  gridSelectors.forEach(function(gridSel){
    document.querySelectorAll(gridSel).forEach(function(grid){
      grid.querySelectorAll('.al-anim-reveal').forEach(function(el,i){
        el.style.transitionDelay=Math.min(i*0.09,0.36)+'s';
      });
    });
  });

  if(!('IntersectionObserver' in window)){
    allEls.forEach(function(el){el.classList.add('al-anim-visible');});
    return;
  }

  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting) return;
      entry.target.classList.add('al-anim-visible');
      observer.unobserve(entry.target);
    });
  },{threshold:0.07,rootMargin:'0px 0px -36px 0px'});

  allEls.forEach(function(el){observer.observe(el);});
}

// ─── PARALLAX HERO ───────────────────────────────────────────────────────────
function initParallax(){
  if(window.innerWidth<769) return;
  var heroRight=document.querySelector('.al-hero__right');
  var heroImg=document.querySelector('.al-hero__img');
  if(!heroRight||!heroImg) return;

  heroImg.style.transition='transform 0.05s linear';

  var ticking=false;
  window.addEventListener('scroll',function(){
    if(ticking) return;
    ticking=true;
    requestAnimationFrame(function(){
      var scrollY=window.pageYOffset;
      var rect=heroRight.getBoundingClientRect();
      if(rect.bottom>0&&rect.top<window.innerHeight){
        var offset=scrollY*0.13;
        heroImg.style.transform='scale(1.08) translateY('+offset+'px)';
      }
      ticking=false;
    });
  },{passive:true});
}

// ─── INIT ─────────────────────────────────────────────────────────────────────
function init(){
  initScrollReveal();
  initParallax();
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',init);
} else {
  init();
}

})();
